import {
  base_colorContentBorder,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  margin: 0;
  font-family: ${font_family_weight_regular};
  ${font_md};
  color: ${text_colorTextSecondary};

  p {
    margin: 0;
  }

  /*
    The two wallet marks, side by side on a roomy dialog and stacked once the
    row would squeeze them below their legible width. Both badges are fixed-
    aspect artwork, so the row centers rather than stretching them.
  */
  .AddToWalletModal-wallets {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${spacing(3)};
    margin-top: ${spacing(1)};
  }

  /*
    Apple and Google both publish these badges as complete, non-restylable
    buttons — the artwork carries the whole affordance, so the element around it
    contributes nothing but the hit target and the focus ring.

    No disabled state, deliberately: a badge only renders for a wallet the card
    can actually be provisioned to (presence of the prop IS the verdict), so
    there is no such thing as a badge that is shown but not pressable.
  */
  .AddToWalletModal-badge {
    padding: 0;
    border: none;
    border-radius: ${spacing(2)};
    background: transparent;
    line-height: 0;
    cursor: pointer;

    svg {
      display: block;
      width: auto;
      height: 40px;
      max-width: 100%;
    }
  }

  .AddToWalletModal-unsupported {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    margin-top: ${spacing(3)};
    padding: ${spacing(4)};
    border: 1px solid ${base_colorContentBorder};
    border-radius: ${spacing(2)};
  }
`
